module.exports = __webpack_public_path__ + "img/05_no.193e5c1c.svg";